import { Abi, defineChain, FallbackTransport, getContract } from "viem";
import { Address } from "./address";
import { PublicClient } from "./chain";

export type ContractType<T extends Abi> = ReturnType<
  typeof getContract<FallbackTransport, Address, T, PublicClient>
>;

export const anvil = defineChain({
  id: 8118,
  name: "Anvil",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["https://anvil.silo.finance/"],
    },
  },
  blockExplorers: {
    default: { url: "/", name: "Anvil Explorer" },
  },
});

export const local = defineChain({
  id: 8545,
  name: "Local",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: {
      http: ["http://localhost:8545"],
    },
  },
  blockExplorers: {
    default: { url: "/", name: "Local Explorer" },
  },
});
